import { render, staticRenderFns } from "./VLoader.vue?vue&type=template&id=bd56c83e&scoped=true&lang=pug&functional=true&"
import script from "./VLoader.vue?vue&type=script&lang=js&"
export * from "./VLoader.vue?vue&type=script&lang=js&"
import style0 from "./VLoader.vue?vue&type=style&index=0&id=bd56c83e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "bd56c83e",
  null
  
)

export default component.exports